// extracted by mini-css-extract-plugin
export default {"verifyEmailContainer":"verifyEmail_verifyEmailContainer__GS7B-","verifyEmail":"verifyEmail_verifyEmail__QVlSQ"};